const extractApiData = ({ data }) => data
export default extractApiData
